import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiVersion, EmailValidationRules } from '@core/constants';
import { BaseResponse } from '@core/models/base-response';
import { BaseService } from '@core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService extends BaseService {
  readonly forgotPasswordUrl = 'users/insecure/password/token';

  email = new FormControl('', EmailValidationRules);

  sendRequest(email: string): Observable<BaseResponse<any>> {
    return this.post(
      this.forgotPasswordUrl,
      { email, userType: 'CUSTOMER' },
      {
        apiVersion: ApiVersion.V2,
        useRecaptcha: true,
      }
    );
  }
}
